var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1408 0.292212C13.945 0.0975619 13.628 0.0981976 13.4329 0.293632L6.24739 7.49187C6.18756 7.55181 6.14397 7.62593 6.1207 7.70727L5.40772 10.2001C5.36453 10.3511 5.5048 10.4905 5.65597 10.4468L8.15152 9.72542C8.23296 9.70188 8.30706 9.65809 8.36689 9.59815L13.642 4.31374L11.5314 2.20313L12.2385 1.49602L14.3485 3.60601L15.5524 2.39991C15.7475 2.20448 15.7469 1.88825 15.551 1.6936L14.1408 0.292212Z",
    fill: "#585D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V13.9C14 13.9552 13.9552 14 13.9 14H2.1C2.04477 14 2 13.9552 2 13.9V2.1C2 2.04477 2.04477 2 2.1 2H8",
    stroke: "#585D66",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/edit-pencil-icon.a340a76c5f142c83afc448928826176e.svg";
export { ForwardRef as ReactComponent };